module.exports = __webpack_public_path__ + "static/img/case_tab_02.5f75c48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_tab_02.png
// module id = 4M27
// module chunks = 34